const TOPICS = [
  { title: '最新上映', desc: '本周院线热门大片同步上线', icon: 'ri-calendar-check-line', tag: '热门' },
  { title: '动作猛片', desc: '肾上腺素飙升的硬核动作', icon: 'ri-flashlight-line', tag: '精选' },
  { title: '喜剧合集', desc: '笑到停不下来的高分喜剧', icon: 'ri-emotion-laugh-line', tag: '' },
  { title: '悬疑惊悚', desc: '烧脑反转让你欲罢不能', icon: 'ri-ghost-line', tag: '' },
  { title: '科幻巨制', desc: '视觉震撼的未来世界探索', icon: 'ri-rocket-2-line', tag: '推荐' },
  { title: '动画佳片', desc: '全家共享的精彩动画盛宴', icon: 'ri-movie-line', tag: '' },
  { title: '爱情经典', desc: '感人至深的浪漫爱情故事', icon: 'ri-heart-line', tag: '' },
  { title: '纪录大片', desc: '真实世界比电影更精彩', icon: 'ri-earth-line', tag: '新上' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            电影专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            按类型分类浏览，快速找到你想看的电影，每日更新片源
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {TOPICS.map((item) => (
            <a
              key={item.title}
              href="#index"
              className="group relative flex flex-col items-center text-center p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              {item.tag && (
                <span className="absolute top-2 right-2 px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-800">
                  {item.tag}
                </span>
              )}
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 mb-3 group-hover:bg-primary-100 transition-colors duration-200">
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-800 mb-1 whitespace-nowrap">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}